<div class="dialog-header">
    <button
      mat-icon-button
      type="button"
      class="close-btn"
      [attr.aria-label]="'common.close' | translate"
      (click)="onCancel()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-icon">
    <mat-icon>description</mat-icon>
  </div>

  <h2 mat-dialog-title class="dialog-title">
    {{ 'search_form_standardize.dialog_select_version.title' | translate }}
  </h2>

  <mat-dialog-content>
    <mat-form-field class="w-100" style="font-size: 16px;">
      <mat-label>
        {{ 'search_form_standardize.dialog_select_version.version_label' | translate }}
      </mat-label>
      <mat-select [value]="selectedVersion" disabled>
        <mat-option [value]="selectedVersion">{{ selectedVersion }}</mat-option>
      </mat-select>
    </mat-form-field>
  
    <p class="error-text" *ngIf="errorMessage">{{ errorMessage | translate }}</p>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-center pt-3 pb-2" style="gap: 4%">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="onCancel()"
      style="width: 48%;"
    >
      <mat-icon>cancel</mat-icon>
      {{ 'search_form_standardize.btn_cancel' | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="isLoading"
      (click)="onContinue()"
      style="width: 48%;"
    >
      <mat-icon>arrow_forward</mat-icon>
      {{ (isLoading
          ? 'search_form_standardize.dialog_select_version.processing'
          : 'search_form_standardize.btn_continue') | translate }}
    </button>
  </mat-dialog-actions>
